type SectionTitleProps = {
  title: string;
  subtitle?: string;
};

export function SectionTitle({ title, subtitle }: SectionTitleProps) {
  /* Modified by: Ishan | Soft-contrast section title and subtitle */
  return (
    <div className="mb-3 text-left sm:mb-4">
      <h2 className="text-[18px] font-extrabold tracking-tight text-[#3A3660]">
        {title}
      </h2>
      {subtitle ? (
        <p className="mt-0.5 text-[13px] text-[#6A6688]">{subtitle}</p>
      ) : null}
    </div>
  );
}
